
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import {  AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { setFocus, setTitle } from '../Common/Common';
import DeckGL from '@deck.gl/react';
import { ScatterplotLayer } from '@deck.gl/layers';
import { Map } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const TrackSalesPerson = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [SalesPersonData, setSalesPersonData] = useState([]);
    const [MenuText, setMenuText] = useState("Track Sales Person");
    const [SaveData, setSaveData] = useState({
        SalesPerson: "",
    });

    const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN;
    const MAP_STYLE = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";

    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }));
    }
    const INITIAL_VIEW_STATE = {
        latitude: 28.6353,
        longitude: 77.219,
        zoom: 3,
        bearing: 0,
        pitch: 0,
        maxZoom: 20,
    };
    const CITIES1 = [
        {
            city: "Delhi",
            state: "India",
            coordinates: [77.219, 28.6353],
        },
        {
            city: "Punjab",
            state: "India",
            coordinates: [75.3412, 31.1471]
        },
        {
            city: "Mumbai",
            state: "India",
            coordinates: [72.8777, 19.0760]
        },
        {
            city: "Bangalore",
            state: "India",
            coordinates: [77.5946, 12.9716]
        }
       
    ];
    const [scatterplotData, setScatterplotData] = useState(CITIES1);

    const scatterplotLayer = new ScatterplotLayer({
        id: "Cities",
        data: scatterplotData,
        getPosition: (d) => d.coordinates,
        getFillColor: (d) => [255, 140, 0],
        getLineColor: (d) => [0, 0, 0],
        pickable: true,
        opacity: 0.8,
        stroked: true,
        filled: true,
        radiusScale: 3,
        radiusMinPixels: 3,
        radiusMaxPixels: 4,
        lineWidthMinPixels: 1,
        
    });


    const [layer, setLayer] = useState([scatterplotLayer]);

    const getSalesPerson = () => {
        setSalesPersonData([])
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let SalesPersonDatalist = res.autoCompleteData || [];
                setSalesPersonData(SalesPersonDatalist);
            } else {
                setSalesPersonData([]);
            }
        });
    }

    let SalesPersonArr = []
    for (let i = 0; i < SalesPersonData.length; i++) {
        let mydata = SalesPersonData[i]?.values
        SalesPersonArr.push(mydata)
    };
   
   

    useEffect(() => {
        setFocus('txtSalesPerson');
        setTitle('TrackSalesPerson', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500);
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <div className="col-lg-12 ">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText }</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area" style={{ height: '83vh' }}>
                                <div className="row align-items-end">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("") };
                                                }}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtCustomer'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson ? SaveData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue);
                                                   
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               
                    <div className="col-lg-9 col-md-9 col-sm-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">Map View</h6>
                                </div>
                            </div>
                            <div className="position-relative" style={{ width: '100%', height: '83vh' }}>
                                <DeckGL
                                    initialViewState={INITIAL_VIEW_STATE}
                                    controller={true}
                                    layers={layer}
                                    getTooltip={({ object }) => object && `${object.city}, ${object.state}`}
                                    getCursor={({ isHovering, layer }) =>
                                        layer === "ScatterplotLayer" || isHovering === "pointer" 
                                    }
                                    style={{ width: '100%' }}
                                >
                                    <Map mapStyle={MAP_STYLE} mapboxAccessToken={MAPBOX_ACCESS_TOKEN} />
                                </DeckGL>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
export default TrackSalesPerson